// extracted by mini-css-extract-plugin
module.exports = {"barChart":"barChart___1Pduh"};